import { createConsumer } from "@rails/actioncable"

const App = {};
App.cable = createConsumer();

window.breakdownsImportSubscription = function () {
  App.cable.subscriptions.create({
    channel: "ImportBreakdownsChannel",
  },
    {
      received: function (data) {
        const modal = document.getElementById('importBreakdowns')
        if (!modal) return // pas sur la bonne page / modale absente

        const loadingEl = modal.querySelector('#importLoading')
        const logsEl = modal.querySelector('#importLogs')
        const modalContent = modal.querySelector('.modal-content')

        let html = ""

        if (data.status == "done") {
          html = `<h4>Import terminé !</h4>`
          if (loadingEl) loadingEl.innerHTML = html  // ✅ guard
          return
        }

        if (data.status == "file_error") {
          html = `
        <div class="alert alert-danger text-center m-5">
          ❌❌❌ Le fichier est mal formaté ❌❌❌
        </div>
      `
          if (modalContent) modalContent.innerHTML = html
          return
        }

        if (!logsEl) return // ✅ si les logs ne sont pas injectés, on ne fait rien

        if (data.status == "not_found") {
          html = `<p>❌ NON TROUVÉ : <strong>${data.isin}</strong> - ${data.errors}</p>`
        } else if (data.status == "not_created") {
          html = `<p>❌ NON CRÉÉ : <strong>${data.isin}</strong> - ${data.errors}</p>`
        } else if (data.status == "ok") {
          return
        } else {
          html = `<p>❌ ERREUR : ${data.isin}</p>`
        }

        logsEl.insertAdjacentHTML('beforeend', html)
      }

    })
}
